export default __webpack_public_path__ + "static/media/ebay-marked.62fe5ff0.png";